module.exports = __webpack_public_path__ + "media/images/es_flag-57d7d6f45155067eece767931533fcdc.png";